<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <imports-list
                :context="{ teamId: props.teamId }"
                importType="group"
                :newImportHref="`/kiosk/teams/${props.teamId}/groups/imports/new`"
                :readOnly="team.status === 'closed'"
            >
                <template v-slot:title>Group Imports</template>
                <template v-if="defaultGroupStatus" v-slot:notice>
                    <vx-alert
                        color="info"
                        :closeable="false"
                        shadow
                        class="mb-4"
                        data-test="default-group-status-alert"
                    >
                        New groups will be created as <strong>{{ GROUP_STATUS_LABELS[defaultGroupStatus] }}</strong
                        >.

                        <template v-slot:right>
                            <router-button :to="`/kiosk/teams/${props.teamId}/configuration`" size="sm" color="info">
                                Change
                                <font-awesome-icon widthAuto :icon="faArrowRight" />
                            </router-button>
                        </template>
                    </vx-alert>
                </template>
            </imports-list>
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { VxAlert } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import ImportsList from '~/components/import/ImportsList.vue';
import RouterButton from '~/components/general/RouterButton.vue';
import { useTeamDetails } from '../composables/useTeamDetails';
import { adminTeamsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';

const GROUP_STATUS_LABELS = {
    draft: 'Draft',
    active: 'Active',
};

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team } = useTeamDetails();
const toasted = useToasted();
const defaultGroupStatus = ref<'draft' | 'active' | null>(null);

onMounted(async () => {
    try {
        const response = await adminTeamsClient.getDefaultGroupStatus(props.teamId);
        defaultGroupStatus.value = response.data.default_group_status;
    } catch (error) {
        toasted.error(catchRequestError(error));
    }
});
</script>
